/** Presentation geometry from the accepted page; placeholder rows make no claim about the pending answer count. */
import type { ShopifyResultQuestions } from '@testfeed/shopify-contracts'
import { SkeletonBodyText } from '../shims/SkeletonBodyTextShim'

export function AuthoredAnswersSkeleton({ groups }: { groups: ShopifyResultQuestions['groups'] }) {
  return (
    <div aria-hidden="true">
      <s-stack gap="large-100">
        {groups.map((group) => (
          <s-section key={group.id}>
            <s-stack gap="small-300">
              <SkeletonBodyText lines={2} />
              {group.answers.map((answer) => (
                <s-box key={answer.id} background="subdued" borderRadius="base" padding="base">
                  <s-grid gridTemplateColumns="auto minmax(0, 1fr)" gap="small-300" alignItems="start">
                    <div className="tf-skeleton-placeholder" style={{ inlineSize: 40 }}>
                      <s-box background="subdued" borderRadius="base" inlineSize="100%" blockSize="40px" />
                    </div>
                    <s-stack gap="small-200">
                      <s-box maxInlineSize="240px">
                        <SkeletonBodyText lines={1} />
                      </s-box>
                      <SkeletonBodyText lines={3} />
                    </s-stack>
                  </s-grid>
                </s-box>
              ))}
            </s-stack>
          </s-section>
        ))}
      </s-stack>
    </div>
  )
}
